export default {
	situacao: null,
	isEfetivado: false,
	numeroCasasDecimaisQtde: null,
	numeroCasasDecimaisValores: null,
	quantidade: null,
	cabecalho: {
		numeroAditivoApostila: null,
		dataCriacao: null,
		usuario: null,
		inicioVigencia: null,
		fimVigencia: null,
		idAta: null,
		numeroAta: null,
	},
}
